// Bundled cover-image presets for groups. Files live in `public/group-covers/`
// and are precached by the service worker. The relative path is what gets
// written to `groups/{groupId}.imageUrl` — the Firestore rule's
// `isValidGroupImageUrl` validator accepts this exact shape.
export const GROUP_COVER_PRESETS: readonly string[] = [
  '/group-covers/cover-01.jpg',
  '/group-covers/cover-02.jpg',
  '/group-covers/cover-03.jpg',
  '/group-covers/cover-04.jpg',
  '/group-covers/cover-05.jpg',
  '/group-covers/cover-06.jpg',
  '/group-covers/cover-07.jpg',
  '/group-covers/cover-08.jpg',
  '/group-covers/cover-09.jpg',
  '/group-covers/cover-10.jpg',
  '/group-covers/cover-11.jpg',
  '/group-covers/cover-12.jpg',
]
